(function () {
  'use strict';

  angular.module('app.blogPostOverview', ['ui.router'])

    .config(['$stateProvider', function ($stateProvider) {
      $stateProvider
        .state('home.blogPostOverview', {
          requireLogin: true,
          url: 'blogPostOverview/:url/:relativepath',
          templateUrl: 'app/blogPostOverview/index.html?app_v=deployDate',
          scope: {},
          data: {
            authorizedRoles: ['Administrator', 'User', 'Achoo Analyst'],
            navMarker: ['blogPostOverview', 'index']
          },
          controller: 'blogPostOverviewCtrl',
          controllerAs: 'vm',
          params: {
              url: null,
              relativepath: null
          }
        })
    }]);
})();